import { render, staticRenderFns } from "./comments.vue?vue&type=template&id=629abbcc&scoped=true"
import script from "./comments.vue?vue&type=script&lang=js"
export * from "./comments.vue?vue&type=script&lang=js"
import style0 from "./comments.vue?vue&type=style&index=0&id=629abbcc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "629abbcc",
  null
  
)

export default component.exports